

export const translations = {
    // Danish translations...
    nav_about: 'Om os',
    nav_products: 'Produkter',
    nav_subscribe: 'Abonnement',
    nav_contact: 'Kontakt',
    admin_panel_btn: 'Admin Panel',
    customer_view_btn: 'Kundevisning',
    b2c_view_btn: 'Privat',
    b2b_view_btn: 'Erhverv',
    cart_aria_label: 'Åbn indkøbskurv',
    b2b_portal_btn: 'B2B Portal',
    b2b_logout_btn: 'Log ud',
    customer_login_btn: 'Log ind',
    my_account_btn: 'Min Konto',
    customer_login_title: 'Kunde Login',
    customer_login_subtitle: 'Få adgang til din konto for at se ordrer og administrere abonnementer.',
    account_page_title: 'Min Konto',
    account_page_subtitle: 'Velkommen tilbage, {name}! Administrer din konto her.',
    profile_tab: 'Profil',
    orders_tab: 'Ordrer',
    subscriptions_tab: 'Abonnementer',
    profile_details_title: 'Profiloplysninger',
    address_details_title: 'Adresseoplysninger',
    street_label: 'Gade',
    account_name: 'Navn',
    account_email: 'Email',
    new_password_label: 'Ny Adgangskode',
    confirm_password_label: 'Bekræft Ny Adgangskode',
    update_profile_btn: 'Opdater Profil',
    password_mismatch_error: 'Adgangskoderne stemmer ikke overens.',
    order_history_title: 'Din Ordrehistorik',
    b2b_login_title: 'Login for Erhvervskunder',
    b2b_login_subtitle: 'Få adgang til din engroskonto for at afgive bulkordrer.',
    b2b_login_email_label: 'Firmaets E-mail',
    b2b_login_password_label: 'Adgangskode',
    b2b_login_btn: 'Login til B2B Portal',
    b2b_portal_title: 'Engroskatalog',
    b2b_portal_subtitle: 'Eksklusive priser og bulk-mængder til vores forretningspartnere.',
    b2b_pack_size: 'Pakkestørrelse',
    b2b_case_size: 'Kassestørrelse',
    b2b_rolls_in_case: 'ruller/kasse',
    case: 'kasse',
    hero_title: 'Ren Komfort, Leveret.',
    hero_subtitle: 'Oplev den enkle luksus af premium, miljøvenlige papirnødvendigheder, bragt direkte til din dør. Tænk aldrig på at løbe tør igen.',
    b2b_hero_title: 'Effektiv Forsyning til Din Virksomhed',
    b2b_hero_subtitle: 'Pålidelig levering af kvalitetspapirprodukter i store mængder. Optimer dine indkøb og spar tid med vores erhvervsløsninger.',
    shop_now_btn: 'Produkter',
    subscribe_now_btn: 'Abonnementer',
    b2b_btn: 'Erhvervskunde?',
    about_title: 'Mere End Bare Papir.',
    about_subtitle: 'Papirrullen er en fynsk virksomhed med base i Ullerslev, der specialiserer sig i salg af toiletpapir og køkkenrulle til både private, erhverv og engroskunder. Vi tror på, at alle har ret til kvalitetsprodukter til en fair pris, og vores mål er derfor at gøre hverdagsprodukter som toiletpapir tilgængelige for alle – uden at gå på kompromis med kvalitet eller bæredygtighed.<br /><br />Som en mindre, dedikeret virksomhed tilbyder vi fleksible og skræddersyede løsninger, så du som kunde altid får den løsning, der passer bedst til dine behov – uanset om du driver virksomhed, institution eller blot ønsker en fast levering til hjemmet.<br /><br />Vi tilbyder levering i hele landet, men du kan også vælge at afhente dine varer på et af vores fire afhentningssteder på Fyn. På den måde giver vi vores kunder frihed til at vælge den løsning, der passer bedst til deres hverdag.<br /><br />Hos Papirrullen har vi et stærkt fokus på bæredygtighed og grøn omstilling. Vi arbejder løbende på at reducere vores miljøaftryk og vælge leverandører, der deler vores værdier om ansvarlig produktion og transport.<br /><br />Papirrullen – fordi hverdagen fortjener kvalitet, omtanke og gode priser.',
    feature1_title: 'Bæredygtigt Fremskaffet',
    feature1_text: 'Vores produkter er fremstillet af ansvarligt forvaltede skove og hurtigtvoksende bambus, hvilket sikrer et mindre miljømæssigt fodaftryk med hver rulle.',
    feature2_title: 'Ubesværet Bekvemmelighed',
    feature2_text: 'Livet er travlt. Lad os håndtere det essentielle. Med vores tilpasselige abonnement sparer du tid, penge og besværet med sidste-øjebliks-indkøb.',
    feature3_title: 'Ingen mellemled',
    feature3_text: 'Som direkte importør fra fabrikken kan vi tilbyde vores kunder skarpe og konkurrencedygtige priser. Ved at skære unødvendige mellemled væk, sikrer vi, at du får mest muligt for pengene – uanset om du køber som privatperson, virksomhed eller grossist.',
    products_title: 'Aktuelle produkter',
    products_subtitle: 'Oplev den perfekte blanding af komfort og bæredygtighed. Find det rigtige match til netop dit hjem.',
    b2b_products_title: 'Engrosprodukter',
    b2b_products_subtitle: 'Gennemse vores udvalg af produkter, prissat for erhvervskunder. Perfekt til kontorer, restauranter og institutioner.',
    b2b_video_title: 'Kvalitet i produktion',
    b2b_video_subtitle: 'Få et indblik i vores moderne produktionsfaciliteter og vores forpligtelse til kvalitet i hvert eneste produkt.',
    filter_all: 'Alle Produkter',
    filter_tp: 'Toiletpapir',
    filter_kt: 'Køkkenruller',
    product_details_title: 'Produktdetaljer',
    related_products_title: 'Måske kan du også lide',
    pack_size: 'Pakkestørrelse',
    ply: 'Lag',
    sheets: 'Ark',
    rolls: 'ruller',
    sheets_per_roll: '/rulle',
    delivery_frequency: 'Leveringsfrekvens',
    one_time_purchase: 'Engangskøb',
    weekly: 'Ugentligt',
    monthly: 'Månedligt',
    bimonthly: 'Hver 2. Måned',
    quarterly: 'Hver 3. Måned',
    discount_tag: '(-15%)',
    add_to_cart_btn: 'Læg i Kurv',
    quantity_label: 'Antal',
    decrement_quantity_btn: 'Formindsk antal',
    increment_quantity_btn: 'Forøg antal',
    sub_title: 'Smart, simpelt og helt problemfrit',
    sub_text: 'Gør hverdagen lidt lettere med et Papirrullen-abonnement. Det er ikke bare en levering – det er ro i sindet leveret lige til døren. Få kvalitetsprodukter, faste besparelser og maksimal bekvemmelighed, skræddersyet til din husstand.',
    b2b_sub_title: 'Automatiseret Levering til Erhverv',
    b2b_sub_text: 'Sørg for, at dit firma aldrig løber tør. Vores erhvervsabonnementer sikrer faste leverancer, mængderabatter og forenklet fakturering.',
    perk1: '<strong>Altid 15% rabat</strong> Som abonnent sparer du altid 15% – på hver eneste ordre. En lille tak for din loyalitet.',
    perk2: '<strong>Fuld fleksibilitet</strong> Dit behov kan ændre sig, og det kan dit abonnement også. Opdater, sæt på pause eller stop når som helst. Helt uden besvær.',
    perk3: '<strong>Indstil det én gang – og læn dig tilbage</strong> Slip for at løbe tør og krydse endnu en ting af listen. Vi sørger for, at dine essentials lander hos dig præcis, når du behøver dem.',
    b2b_perk1: '<strong>Mængderabatter:</strong> Jo mere du køber, jo mere sparer du. Få adgang til vores bedste priser.',
    b2b_perk2: '<strong>Planlagt Levering:</strong> Vælg en leveringsplan, der passer til din virksomheds forbrug og lagerkapacitet.',
    b2b_perk3: '<strong>Forenklet Fakturering:</strong> Modtag samlede månedlige eller kvartalsvise fakturaer for nem bogføring.',
    choose_products_btn: 'Byg Dit Abonnement',
    contact_title: 'Kontakt os',
    contact_subtitle: 'Uanset om du har et spørgsmål om vores produkter, et forslag, eller bare vil sige hej, er vi klar til at hjælpe. Send os en linje!',
    form_name: 'Navn',
    form_email: 'E-mail',
    form_message: 'Besked',
    send_message_btn: 'Send',
    form_success_title: 'Tak!',
    form_success_text: 'Din besked er blevet sendt. Vi vender tilbage til dig snarest.',
    cart_title: 'Din Kurv',
    cart_empty: 'Din kurv er tom.',
    cart_subtotal: 'Subtotal',
    checkout_btn: 'Gå til Kassen',
    delivery_suffix: 'levering',
    one_time: 'Engangs',
    coupon_code_placeholder: 'Indtast rabatkode',
    apply_coupon_btn: 'Anvend',
    remove_coupon_btn: 'Fjern',
    coupon_applied: 'Rabatkode anvendt',
    discount: 'Rabat',
    shipping: 'Fragt',
    grand_total: 'Total',
    free_shipping: 'Gratis',
    free_gift: 'Gratis Gave',
    checkout_title: 'Kasse',
    step_auth: 'Godkendelse',
    step_shipping: 'Levering',
    step_payment: 'Betaling',
    step_confirmation: 'Bekræftelse',
    login_title: 'Log ind',
    register_title: 'Opret Konto',
    login_prompt: 'Har du allerede en konto? Log ind',
    register_prompt: 'Ny kunde? Opret en konto',
    login_btn: 'Log ind',
    register_btn: 'Opret Konto',
    password_label: 'Adgangskode',
    error_email_exists: 'En konto med denne e-mail findes allerede.',
    error_invalid_credentials: 'Ugyldig e-mail eller adgangskode.',
    register_success: 'Konto oprettet! Velkommen.',
    full_name: 'Fulde Navn',
    address: 'Adresse',
    city: 'By',
    postal_code: 'Postnummer',
    country: 'Land',
    billing_same_as_shipping: 'Faktureringsadresse er den samme som leveringsadresse',
    card_number: 'Kortnummer',
    expiry_date: 'Udløbsdato',
    cvc: 'CVC',
    back_btn: 'Tilbage',
    next_btn: 'Næste',
    place_order_btn: 'Afgiv Ordre',
    order_confirmed_title: 'Ordre Bekræftet!',
    order_confirmed_text: 'Tak for dit køb. En bekræftelses-e-mail er blevet sendt.',
    continue_shopping_btn: 'Fortsæt med at handle',
    order_summary_title: 'Ordreoversigt',
    delivery_method: 'Leveringsmetode',
    home_delivery: 'Hjemmelevering',
    pickup_point: 'Afhentningssted',
    find_pickup_point_btn: 'Find i nærheden',
    search_pickup_point_placeholder: 'Søg efter by eller postnummer...',
    pickup_point_select_btn: 'Vælg',
    pickup_point_selected: 'Valgt afhentningssted',
    no_pickup_points_found: 'Ingen afhentningssteder fundet.',
    admin_title: 'Admin Dashboard',
    tab_dashboard: 'Dashboard',
    tab_order_history: 'Ordrehistorik',
    tab_products: 'Produkter',
    tab_standard_products: 'Standard Produkter',
    tab_b2b_products: 'B2B Produkter',
    tab_customers: 'Kunder',
    tab_subscriptions: 'Abonnementer',
    tab_coupons: 'Kuponer',
    tab_pickup_points: 'Afhentningssteder',
    tab_newsletter: 'Nyhedsbrev',
    dashboard_revenue: 'Total Omsætning',
    dashboard_new_orders: 'Nye Ordrer (Denne Måned)',
    dashboard_subscriptions: 'Aktive Abonnementer',
    dashboard_sales_chart_title: 'Månedlig Salgsomsætning',
    filter_by_date: 'Filtrer efter Dato',
    filter_by_status: 'Filtrer efter Status',
    filter_by_customer_type: 'Filtrer efter Kundetype',
    reset_filters: 'Nulstil Filtre',
    all_statuses: 'Alle Statusser',
    all_types: 'Alle Typer',
    pagination_prev: 'Forrige',
    pagination_next: 'Næste',
    pagination_page: 'Side',
    pagination_of: 'af',
    col_order_id: 'Ordre ID',
    col_customer: 'Kunde',
    col_date: 'Dato',
    col_total: 'Total',
    col_status: 'Status',
    col_type: 'Type',
    customer_type_col: 'Kundetype',
    col_prod_name: 'Produktnavn',
    col_price: 'Pris',
    col_action: 'Handling',
    col_code: 'Kode',
    col_value: 'Værdi / Gave',
    col_valid_until: 'Gyldig Indtil',
    col_coupons_used: 'Brugte Kuponer',
    edit_btn: 'Rediger',
    delete_btn: 'Slet',
    view_btn: 'Se',
    add_new_product_btn: 'Tilføj Nyt Produkt',
    add_new_b2b_product_btn: 'Tilføj Nyt B2B Produkt',
    add_new_coupon_btn: 'Tilføj Ny Kupon',
    add_new_pickup_point_btn: 'Tilføj Afhentningssted',
    add_new_customer_btn: 'Tilføj Ny Kunde',
    edit_customer_title: 'Rediger Kunde',
    add_customer_title: 'Tilføj Ny Kunde',
    customer_group_label: 'Kundegruppe',
    col_product: 'Produkt',
    col_frequency: 'Frekvens',
    col_next_due: 'Næste Forfald',
    cancel_btn: 'Annuller',
    col_total_orders: 'Totale Ordrer',
    col_total_spent: 'Totalt Brugt',
    col_first_order: 'Første Ordre',
    col_pickup_name: 'Navn',
    col_address: 'Adresse',
    col_availability: 'Tilgængelighed',
    col_admin_access: 'Admin',
    col_b2b_access: 'B2B Adgang',
    edit_product_title: 'Rediger Produkt',
    add_product_title: 'Tilføj Nyt Produkt',
    edit_b2b_product_title: 'Rediger B2B Produkt',
    add_b2b_product_title: 'Tilføj Nyt B2B Produkt',
    product_b2b_price_label: 'B2B Pris (pr. kasse)',
    product_case_size_label: 'Kassestørrelse (pakker)',
    product_name_label: 'Produktnavn',
    product_desc_label: 'Beskrivelse',
    product_price_label: 'Pris (EUR)',
    product_img_label: 'Produktbilleder',
    product_type_label: 'Produkttype',
    product_ply_label: 'Lag',
    product_sheets_label: 'Ark pr. Rulle',
    product_pack_label: 'Pakkestørrelse (ruller)',
    save_btn: 'Gem Ændringer',
    cancel_modal_btn: 'Annuller',
    close_btn: 'Luk',
    edit_pickup_point_title: 'Rediger Afhentningssted',
    add_pickup_point_title: 'Tilføj Afhentningssted',
    pickup_point_name_label: 'Navn',
    pickup_point_address_label: 'Adresse',
    pickup_point_city_label: 'By',
    pickup_point_postal_code_label: 'Postnummer',
    pickup_point_country_label: 'Land',
    pickup_point_availability_label: 'Tilgængelighed',
    pickup_point_lat_label: 'Breddegrad',
    pickup_point_lng_label: 'Længdegrad',
    order_details_title: 'Ordredetaljer',
    customer_details_title: 'Kundeoplysninger',
    customer_summary_title: 'Kundeoversigt',
    coupons_used_title: 'Brugte Kuponer',
    no_coupons_used: 'Ingen kuponer brugt endnu.',
    edit_coupon_title: 'Rediger Kupon',
    add_coupon_title: 'Tilføj Ny Kupon',
    coupon_code_label: 'Kuponkode',
    coupon_type_label: 'Type',
    coupon_value_label: 'Værdi (%)',
    coupon_gift_label: 'Gaveprodukt',
    coupon_valid_from_label: 'Gyldig Fra',
    coupon_valid_until_label: 'Gyldig Indtil',
    coupon_uses_label: 'Brug pr. Kunde',
    coupon_region_label: 'Gyldige Regioner',
    select_gift_product: 'Vælg et gaveprodukt',
    status_active: 'Aktiv',
    status_expired: 'Udløbet',
    status_paused: 'Sat på pause',
    status_cancelled: 'Annulleret',
    cancel_order_btn: 'Annuller Ordre',
    request_return_btn: 'Anmod om Returnering',
    view_details_btn: 'Se Detaljer',
    no_orders_found: 'Du har endnu ikke afgivet nogen ordrer.',
    subscription_product: 'Produkt',
    subscription_frequency: 'Frekvens',
    subscription_status: 'Status',
    subscription_actions: 'Handlinger',
    pause_subscription_btn: 'Sæt på Pause',
    resume_subscription_btn: 'Genoptag',
    cancel_subscription_btn: 'Annuller Abonnement',
    no_subscriptions_found: 'Du har ingen aktive abonnementer.',
    edit_order_title: 'Rediger Ordre',
    edit_b2b_order_title: 'Rediger B2B Ordre',
    order_items_label: 'Ordre Varer',
    // FIX: Renamed duplicate key 'quantity_label' to 'b2b_quantity_label' to avoid conflict.
    b2b_quantity_label: 'Antal (Kasser)',
    update_order_btn: 'Opdater Ordre',
    pending: 'Afventer',
    shipped: 'Afsendt',
    delivered: 'Leveret',
    cancelled: 'Annulleret',
    theme_switcher: 'Tema',
    newsletter_title: 'Tilmeld dig vores nyhedsbrev',
    newsletter_subtitle: 'Få de seneste nyheder, tilbud og opdateringer direkte i din indbakke.',
    newsletter_placeholder: 'Din e-mailadresse',
    newsletter_subscribe_btn: 'Tilmeld',
    newsletter_success: 'Tak fordi du tilmeldte dig!',
    in_stock: 'På Lager',
    low_stock: 'Få på lager',
    out_of_stock: 'Udsolgt',
    only_left: 'Kun {count} tilbage!',
    insufficient_stock_error: 'Ikke nok på lager til at tilføje {quantity} stk.',
    insufficient_stock_cart_warning: 'Utilstrækkeligt lager for den ønskede mængde.',
    col_stock: 'Lager',
    product_stock_label: 'Lagerbeholdning',
    subscribers_title: 'Abonnenter',
    composer_title: 'Nyhedsbrev Værktøj',
    add_subscriber_btn: 'Tilføj Abonnent',
    export_csv_btn: 'Eksporter .CSV',
    col_email: 'Email',
    col_subscribed_at: 'Tilmeldt Dato',
    subject_label: 'Emne',
    body_label: 'Indhold',
    generate_with_gemini_btn: 'Generer med AI',
    send_newsletter_btn: 'Send Nyhedsbrev',
    newsletter_send_test_btn: "Test Nyhedsbrev",
    // FIX: Add a new translation key for the AI prompt context field.
    newsletter_ai_prompt: 'AI Prompt / Kontekst',
    footer_company_name: "Papirrullen ApS",
    cookie_consent: "Vi bruger cookies for at forbedre din oplevelse. Accepterer du brugen af cookies?",
    footer_address_line1: "Industrivej 10",
    footer_address_line2: "5540 Ullerslev, Danmark",
    footer_cvr: "CVR: 12345678",
    footer_information: 'Information',
    footer_follow_us: 'Følg os',
    footer_link_terms: "Handelsbetingelser",
    footer_link_delivery: "Leveringsinformation",
    footer_link_privacy: "Privatlivspolitik",
    footer_link_returns: "Returpolitik",
    footer_copyright: "© {year} Papirrullen. Alle rettigheder forbeholdes.",
    legal_title_terms: "Handelsbetingelser",
    legal_content_terms: `
        <h3>1. Anvendelse</h3>
        <p>Disse handelsbetingelser gælder for alle køb foretaget på Papirrullen.dk. Aftalen indgås mellem dig som kunde og Papirrullen ApS (CVR: 12345678).</p>
        <h3>2. Bestilling og Betaling</h3>
        <p>Når du afgiver en ordre, modtager du en ordrebekræftelse på e-mail. Betaling kan ske med gængse betalingskort. Beløbet trækkes først, når varen afsendes.</p>
        <h3>3. Priser</h3>
        <p>Alle priser er angivet i Danske Kroner (DKK) og er inklusiv 25% moms. Der tages forbehold for trykfejl og prisændringer.</p>
    `,
    legal_title_delivery: "Leveringsinformation",
    legal_content_delivery: `
        <h3>1. Leveringstid</h3>
        <p>Vi bestræber os på at levere dine varer inden for 1-3 hverdage efter bestilling. I travle perioder kan der forekomme længere leveringstid.</p>
        <h3>2. Fragtpriser</h3>
        <p>Standardfragt koster 45,00 kr. Ved køb over 500 DKK tilbyder vi gratis fragt til pakkeshops i Danmark. Du kan også vælge at afhente gratis på et af vores afhentningssteder.</p>
        <h3>3. Afhentningssteder</h3>
        <p>Vi tilbyder afhentning på fire lokationer på Fyn. Du vil modtage en e-mail, når din ordre er klar til afhentning.</p>
    `,
    legal_title_privacy: "Privatlivspolitik",
    legal_content_privacy: `
        <h3>1. Dataansvarlig</h3>
        <p>Papirrullen ApS er dataansvarlig for de oplysninger, du giver os. Vi behandler dine personoplysninger i overensstemmelse med gældende lovgivning, herunder GDPR.</p>
        <h3>2. Hvilke oplysninger indsamler vi?</h3>
        <p>Vi indsamler navn, adresse, e-mail og telefonnummer for at kunne behandle og levere din ordre. Betalingsoplysninger håndteres sikkert af vores betalingsudbyder og gemmes ikke af os.</p>
        <h3>3. Dine rettigheder</h3>
        <p>Du har ret til at få indsigt i, rettet eller slettet dine personoplysninger. Kontakt os på info@papirrullen.dk for at gøre brug af dine rettigheder.</p>
    `,
    legal_title_returns: "Retur- og Reklamationsret",
    legal_content_returns: `
        <h3>1. Fortrydelsesret</h3>
        <p>Du har 14 dages fuld fortrydelsesret, når du handler hos os. Fristen løber fra den dag, du modtager varen. Varen skal returneres i væsentligt samme stand og mængde.</p>
        <h3>2. Returnering</h3>
        <p>Ønsker du at returnere en vare, skal du kontakte os på forhånd. Du afholder selv de direkte udgifter i forbindelse med varens returforsendelse.</p>
        <h3>3. Reklamation</h3>
        <p>Der gives 2 års reklamationsret i henhold til købeloven. Dette betyder, at du enten kan få varen repareret, ombyttet, pengene tilbage eller afslag i prisen, afhængig af den konkrete situation.</p>
    `
};